var Marionette = require('marionette')
var $ = require('jquery')
var now = (new Date()).getTime()
var day = 24 * 60 * 60 * 1000

module.exports = Marionette.ItemView.extend({
  template: false,

  ui: {
    button: '.js-close--element'
  },

  options: {
    hideElementClass: 'is-transition--height-hidden',
    storageDays: 30
  },

  events: {
    'click @ui.button': 'closeElement'
  },

  initialize: function () {
    if (typeof window.localStorage !== 'undefined') {
      var value = window.localStorage.getItem(this.options.storageName)
      if (!value || now > Number(value)) {
        $(this.options.parent).removeClass(this.getOption('hideElementClass'))
      }
    }
  },

  closeElement: function () {
    $(this.options.parent).addClass(this.getOption('hideElementClass'))
    if (typeof window.localStorage !== 'undefined') {
      window.localStorage.setItem(this.options.storageName, now + (Number(this.options.storageDays) * day))
    }
  }

})
